import {
  ALL_MULTI_SOURCE,
  ALL_MULTI_SOURCE_INFO,
  CLEAR_MULTISOURCE,
  EXTRACTED_ONE_CASE_INFO,
  UPDATE_FILE_PROGRESS,
  UPDATE_MAIN_INFO_CASE,
  UPDATE_MAIN_INFO_CASE_BULK,
} from '../../types'

const INITIAL_STATE = {
  getAllMultiSource: [],
  caseInfoId: null,
  getOneExtractInfo: {},
  getAllMultiSourceInfo: [],
  fileProgress: {},
  totalRecords: 0,
}

const AUDIT_OLD_KEYS = new Set([
  // 'old_initialReceiptDate',
  // 'old_countryofIncidence',
  // 'old_productId',
  // 'old_reportType',
  // 'old_reportEventDesc',
  // 'old_localCriteriaReportType',
  // 'old_seriousAE',
  // 'old_caseSummary',
])

const normalizeId = (value) =>
  value === null || value === undefined || value === '' ? null : String(value)

const caseKey = (item = {}) => {
  const caseInfoId = normalizeId(item.caseInfoId)
  if (caseInfoId) return `case:${caseInfoId}`
  const fileInfoId = normalizeId(item.fileInfoId)
  const caseIndex =
    item.caseIndex === null || item.caseIndex === undefined
      ? null
      : String(item.caseIndex)
  if (fileInfoId && caseIndex !== null) return `file:${fileInfoId}:idx:${caseIndex}`
  return null
}

const mergeCaseRows = (rows = [], update = {}) => {
  const key = caseKey(update)
  if (!key) return rows

  const cleanPayload = Object.fromEntries(
    Object.entries(update).filter(([, value]) => value !== undefined),
  )

  const index = rows.findIndex((item) => caseKey(item) === key)
  if (index < 0) return [...rows, cleanPayload]

  const existing = rows[index] || {}
  const existingMain = existing?.main_info || {}
  const incomingMain =
    cleanPayload?.main_info && typeof cleanPayload.main_info === 'object'
      ? cleanPayload.main_info
      : {}
  const preservedAudit = Object.fromEntries(
    Object.entries(existingMain).filter(([k]) => AUDIT_OLD_KEYS.has(k)),
  )

  const merged = {
    ...existing,
    ...cleanPayload,
    main_info: {
      ...existingMain,
      ...incomingMain,
      ...preservedAudit,
    },
  }

  return [...rows.slice(0, index), merged, ...rows.slice(index + 1)]
}

const multiSourceReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action

  const safeSources = Array.isArray(state.getAllMultiSourceInfo)
    ? state.getAllMultiSourceInfo
    : []

  switch (type) {
    case ALL_MULTI_SOURCE:
      return {
        ...state,
        getAllMultiSource: payload?.data || [],
        totalRecords: payload?.pagination?.totalRecords || 0,
      }

    case EXTRACTED_ONE_CASE_INFO:
      return {
        ...state,
        getOneExtractInfo: payload?.extractedInfo || {},
        caseInfoId: payload?.caseInfoId || null,
      }

    case ALL_MULTI_SOURCE_INFO: {
      const newSource = {
        sourceId: payload?.sourceId ?? null,
        fileName: payload?.fileName || '',
        extractedInfo: Array.isArray(payload?.extractInfo)
          ? payload.extractInfo
          : [],
      }

      const alreadyExists = safeSources.some(
        (item) => normalizeId(item.sourceId) === normalizeId(newSource.sourceId),
      )

      return {
        ...state,
        getAllMultiSourceInfo: alreadyExists
          ? safeSources.map((item) =>
              normalizeId(item.sourceId) === normalizeId(newSource.sourceId)
                ? {
                    ...item,
                    ...newSource,
                    extractedInfo: Array.isArray(item.extractedInfo)
                      ? item.extractedInfo
                      : [],
                  }
                : item,
            )
          : [newSource, ...safeSources],
      }
    }
    case CLEAR_MULTISOURCE:
      return { ...state, getAllMultiSourceInfo: [] }

    case UPDATE_MAIN_INFO_CASE:
      return {
        ...state,
        getAllMultiSourceInfo: safeSources.map((source) => {
          if (normalizeId(source.sourceId) !== normalizeId(payload.sourceId))
            return source

          const extractedInfo = Array.isArray(source.extractedInfo)
            ? source.extractedInfo
            : []

          const isFieldPatch =
            payload?.field != null && payload?.caseInfoId != null

          if (isFieldPatch) {
            const { caseInfoId, field, value, oldField, oldValue } = payload
            return {
              ...source,
              extractedInfo: extractedInfo.map((item) => {
                if (normalizeId(item.caseInfoId) !== normalizeId(caseInfoId))
                  return item

                const existingMain = item?.main_info || {}
                const nextMain = {
                  ...existingMain,
                  [field]: value,
                }
                if (oldField && AUDIT_OLD_KEYS.has(oldField)) {
                  nextMain[oldField] = oldValue
                }

                return {
                  ...item,
                  main_info: nextMain,
                }
              }),
            }
          }

          return {
            ...source,
            extractedInfo: mergeCaseRows(extractedInfo, payload),
          }
        }),
      }

    case UPDATE_MAIN_INFO_CASE_BULK:
      return {
        ...state,
        getAllMultiSourceInfo: safeSources.map((source) => {
          if (normalizeId(source.sourceId) !== normalizeId(payload?.sourceId))
            return source

          const updates = Array.isArray(payload?.updates) ? payload.updates : []
          const mergedRows = updates.reduce(
            (acc, update) => mergeCaseRows(acc, update),
            Array.isArray(source.extractedInfo) ? source.extractedInfo : [],
          )

          return {
            ...source,
            extractedInfo: mergedRows,
          }
        }),
      }

    case UPDATE_FILE_PROGRESS:
      return {
        ...state,
        fileProgress: {
          ...(state.fileProgress || {}),
          [payload?.caseInfoId]: payload?.progress,
        },
      }

    default:
      return state
  }
}

export default multiSourceReducer
